export default "<title-bar [titleName]=\"'Account'\" class=\"p-0 m-0\" ></title-bar>\r\n<p>transport-manager-account works!</p>\r\n ";